import { articleAnchorId } from '../../lib/briefModel.js';
import BriefArticleShare from './BriefArticleShare.jsx';

export default function BriefArticleCard({ article, palette, isTopStory }) {
  const anchorId = article.articleId ? articleAnchorId(article.articleId) : undefined;

  return (
    <article
      id={anchorId}
      className="scroll-mt-28 bg-white border border-[#D4D4D4] border-t-[3px] border-t-black mb-6 transition-shadow"
    >
      <div className="px-6 sm:px-7 pt-6 pb-4 flex flex-wrap items-center gap-3">
        <span
          className="inline-flex items-stretch border rounded-sm overflow-hidden font-mono text-[12px] font-bold uppercase tracking-wide"
          style={{
            backgroundColor: palette.track,
            borderColor: palette.accent,
            color: palette.ink,
          }}
        >
          <span
            className="px-3 py-2 font-bold text-[14px]"
            style={{ color: palette.bar }}
          >
            {article.number}
          </span>
          <span
            className="w-px shrink-0"
            style={{ backgroundColor: palette.accent }}
            aria-hidden="true"
          />
          <span className="px-3 py-2 tracking-[0.16em]">{article.category}</span>
        </span>
        {isTopStory ? (
          <span className="inline-block bg-black text-white px-3 py-2 text-[12px] font-bold tracking-[0.16em] uppercase">
            Top Story
          </span>
        ) : null}
      </div>

      <div className="px-6 sm:px-7 pb-7">
        <h3
          tabIndex={-1}
          className="font-sans text-[24px] sm:text-[26px] lg:text-[28px] font-extrabold leading-tight text-black tracking-tight m-0 mb-4 outline-none"
        >
          {article.title}
        </h3>

        {article.takeaway ? (
          <div
            className="mb-4 pl-3.5 py-3 font-sans text-[17px] sm:text-[18px] leading-snug font-semibold"
            style={{
              backgroundColor: palette.track,
              borderLeft: `3px solid ${palette.bar}`,
              color: palette.ink,
            }}
          >
            <strong className="font-extrabold">KEY TAKEAWAY:</strong> {article.takeaway}
          </div>
        ) : null}

        {article.imageUrl ? (
          <img
            src={article.imageUrl}
            alt={article.imageAlt || ''}
            className="w-full block h-auto mb-5 rounded-sm"
            loading="lazy"
          />
        ) : null}

        {article.summary ? (
          <p className="font-sans text-[17px] sm:text-[18px] leading-[1.65] text-[#525252] m-0 mb-4">
            <strong className="text-black font-bold">SUMMARY:</strong> {article.summary}
          </p>
        ) : null}

        {article.source ? (
          <p className="font-sans text-[15px] sm:text-[16px] text-[#525252] m-0 mb-6">
            <strong className="text-black font-bold">SOURCE:</strong> {article.source}
          </p>
        ) : null}

        {article.url || article.webUrl ? (
          <div className="flex flex-wrap items-center gap-4 w-full">
            {article.url ? (
              <a
                href={article.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center min-h-[44px] px-7 py-3.5 border-2 border-black rounded-full font-sans text-[14px] font-bold tracking-[0.12em] uppercase text-black no-underline hover:bg-black hover:text-white transition-colors"
              >
                Read Original Source →
              </a>
            ) : null}
            {article.webUrl ? (
              <div className="ml-auto">
                <BriefArticleShare article={article} />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </article>
  );
}
